/**
 * Enumeration of all supported element types, which can be loaded and rendered
 * in the course-viewer.
 */
let BlockElementTypes = /*#__PURE__*/function (BlockElementTypes) {
  BlockElementTypes["ACCORDION"] = "Accordion";
  BlockElementTypes["AUDIO"] = "Audio";
  BlockElementTypes["COMPLEXT_CONTENT"] = "Complexcontent";
  BlockElementTypes["IFRAME"] = "Iframe";
  BlockElementTypes["IMAGE"] = "Image";
  BlockElementTypes["RICHTEXT"] = "Richtext";
  BlockElementTypes["SLIDER"] = "Slider";
  BlockElementTypes["VIDEO"] = "Video";
  BlockElementTypes["PAGE"] = "Page";
  BlockElementTypes["IBOOK"] = "Ibook";
  return BlockElementTypes;
}({});

export { BlockElementTypes };
//# sourceMappingURL=reference-block.js.map
